import styled from 'styled-components';

import { getThemeColor } from '@utils/styled';

import Button from '@common/components/Button';
import Typography from '@common/components/Typography';

export const AddToBasketButton = styled(Button)`
  ${({ theme }) => theme.getFluidSpacing('margin-top', 'equal', 2)}
  width: 100%;

  &:disabled {
    border: 0.1rem solid ${getThemeColor('bluegrey.80')};
  }
`;

export const QuantityLabel = styled(Typography).attrs({ variant: 'body2' })`
  ${({ theme }) => theme.getFluidSpacing('margin-top', 'equal', 5)};
  ${({ theme }) => theme.getFluidSpacing('margin-bottom', 'equal', 5)};
  color: ${getThemeColor('bluegrey.60')};
`;
